import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ResponseDefault } from 'src/app/shared/data/response-default.interface';
import { BaseService } from 'src/app/shared/services/base.service';
import { ToastService } from 'src/app/shared/services/toast.service';
import { environment } from 'src/environments/environment';

export interface IPartner {
  id: string;
  active: boolean;
  type: number;
  name: string;
  trading: string;
  document: string;
  code: string;
  email: string;
  phone: string;
  logo: string;

  subsidiaries: [];
  costCenters: [];

  createdDate?: string;
  createdBy?: string;
  updatedDate?: string;
  updatedBy?: string;
}

@Injectable({
  providedIn: 'root'
})
export class PartnerService extends BaseService {
  private readonly apiUrl = `${this.urlService}${environment.microservices.company}partner`;

  constructor(private readonly http: HttpClient, protected readonly toast: ToastService) {
    super(toast);
  }
  listarParceirosAtivas(): Observable<ResponseDefault<IPartner[]>> {
    return this.http.get<ResponseDefault<IPartner[]>>(`${this.apiUrl}/ListActive`);
  }
}
